import { render, staticRenderFns } from "./feedbackreport.vue?vue&type=template&id=c2819df2&scoped=true&"
import script from "./feedbackreport.vue?vue&type=script&lang=js&"
export * from "./feedbackreport.vue?vue&type=script&lang=js&"
import style0 from "./feedbackreport.vue?vue&type=style&index=0&id=c2819df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2819df2",
  null
  
)

export default component.exports